/* eslint-disable */
import { React, useEffect } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  selectError,
  selectAuthStatus,
  postVerifyCodeBypass,
  getScholarshipId,
} from "../../utils/auth/authSlice";

import PageWrapper from "../PageWrapper";
import InputText from "../GenericFormikComponents/InputText";
import Label from "../Label";
import PrimaryButton from "../SFUCentralThemedComponents/PrimaryButton";
import ProgressSpinnerPR from "../PrimeReact/ProgressSpinnerPR";

export default function VerificationBypassPage({ scholarshipType }) {
  const dispatch = useDispatch();
  const error = useSelector(selectError);
  const authStatus = useSelector(selectAuthStatus);
  const spinnerStatus = authStatus === "loading";
  const { token } = useParams();
  useEffect(() => {
    dispatch(getScholarshipId({ scholarshipType }));
  }, []);

  return (
    <PageWrapper>
      <Formik
        initialValues={{ studentId: "" }}
        validationSchema={Yup.object().shape({
          studentId: Yup.string()
            .trim()
            .nullable()
            .required("Please enter a student ID")
            .matches(/^[0-9]+$/, "Student ID must only contain numbers")
            .min(9, "Must be exactly 9 digits")
            .max(9, "Must be exactly 9 digits"),
        })} // validation schema is defined at the top of the page
        onSubmit={(values) => {
          values.scholarshipName = "uggla-family-scholarship";
          dispatch(postVerifyCodeBypass({ ...values, token }));
          window.scrollTo(0, 0);
        }}
      >
        <Form>
          <div className="p-grid">
            <div className="p-col-12">
              <h1>Student ID Confirmation</h1>
            </div>
            <div className="p-col-12">
              <p>Please enter your Student ID</p>
            </div>

            <div className="p-col-12 p-md-6">
              <Label htmlFor="studentId">
                <span className="p-col-12 p-col-nogutter">Student ID</span>
                <InputText
                  name="studentId"
                  placeholder="Enter Student ID"
                  className="p-col-12"
                />
              </Label>
            </div>

            {error ? (
              <div className="p-col-12">
                <span className="p-invalid">{error}</span>
              </div>
            ) : (
              ""
            )}
          </div>

          <div className="p-grid button-navigation-container">
            <div className="p-col-12">
              <PrimaryButton type="submit" disabled={spinnerStatus}>
                Login
              </PrimaryButton>
            </div>
          </div>
        </Form>
      </Formik>

      {spinnerStatus ? <ProgressSpinnerPR /> : ""}
    </PageWrapper>
  );
}
